import { createAction, props } from '@ngrx/store';
import { ResponseCustomerChallengeGenerate, RequestCustomerChallengeGenerate } from '../../shared/interfaces';
import { CustomerChallengeGenerateTypes } from '../../shared/enums';


export const getCustomerChallengeGenerate = createAction(
    CustomerChallengeGenerateTypes.CUSTOMER_CHALLENGE_GENERATE,
    props<{ request: RequestCustomerChallengeGenerate}>()
);

export const getCustomerChallengeGenerateSuccess = createAction(
    CustomerChallengeGenerateTypes.CUSTOMER_CHALLENGE_GENERATE_SUCCESS,
    props<{ response: ResponseCustomerChallengeGenerate }>()
);

export const getCustomerChallengeGenerateError = createAction(
    CustomerChallengeGenerateTypes.CUSTOMER_CHALLENGE_GENERATE_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    CustomerChallengeGenerateTypes.CLEAN_STATE
);
